import { UNSAFE_useMediaQuery as useMediaQuery } from '@atlaskit/primitives/responsive';
import { useState } from 'react';

/*
 * useMediumScreen
 *
 * This hook is used to determine if the current viewport is medium screen(mobile or tablet) not large screen(desktop).
 */

export const useMediumScreen = () => {
  var _mq$matches;
  const mq = useMediaQuery('below.md', event => setShowBelowMedium(event.matches));
  const [showBelowMedium, setShowBelowMedium] = useState((_mq$matches = mq === null || mq === void 0 ? void 0 : mq.matches) !== null && _mq$matches !== void 0 ? _mq$matches : false);
  return showBelowMedium;
};